export default "__VITE_ASSET__DV5Nc3wV__"